import { CardState } from '@witkac/kartamiejska-shared';
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { RouteConfig } from 'vue-router';

import RouterView from '@/components/RouterView.vue';
import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import Card from '@/views/card/Card.vue';
import { cardStateOrder, getCardStatePermission } from '@/views/card/cardStatePermissions';

async function hasAccessToCardState(state: string): Promise<boolean> {
  const permission = getCardStatePermission(state);
  const checked = (store.state as any).access.checked;

  if (checked[permission] !== undefined) {
    return !!checked[permission];
  }

  const result = await store.dispatch('access/check', [permission]);
  if (result && result.length) {
    return !!result[0];
  }

  return !!(store.state as any).access.checked[permission];
}

async function getFirstAllowedCardState(): Promise<string | undefined> {
  const permissions = Array.from(new Set(cardStateOrder.map(getCardStatePermission)));
  await store.dispatch('access/check', permissions);

  const checked = (store.state as any).access.checked;
  return cardStateOrder.find(state => !!checked[getCardStatePermission(state)]);
}

export const cardRoute: RouteConfig = {
  path: 'cards',
  name: 'cards',
  redirect: { name: 'cardsByState', params: { state: CardState[CardState.NOT_CONFIRMED] } },
  component: RouterView,
  children: [
    {
      path: ':state',
      name: 'cardsByState',
      component: Card,
      beforeEnter: async (to, from, next) => {
        try {
          store.commit('breadcrumbs/set', [{ text: 'Karty', disabled: true }]);

          const requestedState = to.params.state;
          const canAccessRequestedState = await hasAccessToCardState(requestedState);

          if (!canAccessRequestedState) {
            const allowedState = await getFirstAllowedCardState();

            if (!allowedState) {
              store.dispatch('notifyError', { title: 'Brak uprawnień do podglądu kart.' });
              next({ name: 'dashboard' });
              return;
            }

            next({
              name: 'cardsByState',
              params: { state: allowedState },
              query: to.query,
              replace: true
            });
            return;
          }

          await Promise.all([
            store.dispatch('card/list', {
              ...baseFilters(to),
              state: requestedState,
              collectionPointId: tryParseInt(to.query.collectionPointId)
            }),
            store.dispatch('collectionPoint/list', { count: -1 })
          ]);

          next();
        } catch (error) {
          store.dispatch('notifyError', { title: 'Nie udało się pobrać listy kart.' });
          next(false);
        }
      }
    }
  ],
  meta: { toolbarTitle: 'Karty mieszkańców' }
};
